export const DoNotTrack = Object.freeze({
  DISABLED: '0',
  ENABLED: '1',
});

export const Event = Object.freeze({
  LOAD: 'load',
  REGISTER: 'register',
  JOIN: 'join',
  SEND: 'send',
  POLLED: 'polled',
  LIVE_QUESTION_PUBLISHED: 'question',
  LIVE_ANSWER_PUBLISHED: 'answer',
});

export const ImplicitConsentEvents = Object.freeze([Event.REGISTER, Event.SEND, Event.POLLED]);
export type EventName = keyof typeof Event;
export type EventValue = (typeof Event)[EventName];

export const LocalStorageKey = Object.freeze({
  CONTACT_IDENTITIES: 'wistia:contact:identities',
  REGISTRATION: 'wistia:live:analyticsEvents',
  WISTIA: 'wistia',
});

export const MediaType = Object.freeze({
  AUDIO: 'Audio',
  VIDEO: 'Video',
});

export const PlayerType = Object.freeze({
  ES3: 'es3',
  ES5: 'es5',
  LIVE_REGISTRATION: 'liveRegistration',
  LIVE_CHAT: 'liveChat',
  LIVE_POLL: 'livePoll',
  LIVE_QA: 'liveQA',
  MODERN: 'modern',
});

type PlayerTypes = keyof typeof PlayerType;
export type PlayerTypeName = (typeof PlayerType)[PlayerTypes];

export const Scope = Object.freeze({
  REGISTRATION: 'registration',
  LIVE_CHAT: 'live_chat',
  LIVE_POLL: 'live_poll',
  LIVE_QA: 'live_qa',
});

type ScopeKeys = keyof typeof Scope;
export type ScopeValue = (typeof Scope)[ScopeKeys];

export interface FormFieldData {
  id: number;
  value: string;
}
